import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_userSummary.css'
import { FormattedDistance } from 'shared/units'
import { FormattedDuration } from 'shared/units'
import { FormattedEnergy } from 'shared/units'
import { LONG } from 'shared/units/constants'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'
const statsArray = ['distance', 'duration', 'energy', 'activity_count']

class StatsSummary extends Component {
  static propTypes = {
    totals: PropTypes.object,
  }

  state = {
    currentStat: 0,
  }

  handleClick = () => {
    if (this.state.currentStat === statsArray.length - 1) {
      this.setState({ currentStat: 0 })
    } else {
      this.setState({ currentStat: this.state.currentStat + 1 })
    }
  }

  render () {
    const { totals } = this.props
    return (
      <div className={styles.statsBox}>
        <div className={styles.userPoints}>
          <div className={styles.item}>
            {statsArray[this.state.currentStat] === 'distance' ?
              <div className={styles.totalSummary}>
                <FormattedDistance value={totals.distance} digits={2} unit={LONG} />
              </div>
            : null}
            {statsArray[this.state.currentStat] === 'duration' ?
              <div className={styles.totalSummary}>
                <FormattedDuration value={totals.duration} digits={2} unit={LONG} />
              </div>
            : null}
            {statsArray[this.state.currentStat] === 'energy' ?
              <div className={styles.totalSummary}>
                <FormattedEnergy from='joules' value={totals.energy} digits={0} />
              </div>
            : null}
            {statsArray[this.state.currentStat] === 'activity_count' ?
              <div className={styles.totalSummary}>
                <div className={styles.totalSummary}>{totals.activity_count}</div>
                <span className={styles.itemDescription}>
                  <FormattedMessage id='home.userSummary.workouts' defaultMessage='workouts' />
                </span>
              </div>
            : null}
          </div>
        </div>
        <Svg onClick={this.handleClick} className={styles.statsChanger} name='chevron_right' />
      </div>
    )
  }
}
export default StatsSummary



// WEBPACK FOOTER //
// ./src/components/home/summary/StatsSummary.jsx